<template>
  <b-form class="service-form">
    <b-form-group label="Название службы">
      <b-form-input v-model="value.name" />
    </b-form-group>
  </b-form>
</template>

<script>
import ServiceModel from "@/components/Forms/Service/models/serviceModel";

export default {
  props: {
    value: {
      type: ServiceModel,
      required: true
    }
  }
};
</script>
